import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AbstractAppStatsSearch } from '../../../../models/appstats/appstats-search.model';
import { TransactionalEmailEventResult } from '../../../../models/appstats/transactional-email/transactional-email-event-result.model';
import { ErrorHandlingService } from '../../../error-handling/error-handling.service';
import { HttpHeaderConstants } from '../../../http-header.constant';
import { SpinnerService } from '../../../spinner';
import { catchError, finalize, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TransactionalEmailEventResultService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private APPSTATS_RESULT_URL = environment.publicApiHost + '/appcloud/transactional-email-event-results';

    search(search: TransactionalEmailEventResultSearch): Observable<TransactionalEmailEventResult[]> {
        const process = 'TransactionalEmailEventResultService.search';
        this.#spinnerService.addProcess(process, 'Retrieving your event results...');

        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams(),
        };

        for (const [key, value] of Object.entries(search)) {
            httpOptions.params = httpOptions.params.set(key, value as string | number | boolean);
        }

        return this.#http.get<TransactionalEmailEventResult[]>(this.APPSTATS_RESULT_URL, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(error, false, 'An error occurred. Please try again later.');
                return of<TransactionalEmailEventResult[]>();
            }),
            finalize(() => this.#spinnerService.completeProcess(process))
        );
    }
}

export interface TransactionalEmailEventResultSearch extends AbstractAppStatsSearch {
    appinstanceId?: number;
    transactionalEmailEventIds?: number[];
}
